export function diffForHuman(date) {
    const formatter = new Intl.RelativeTimeFormat("en", {
        numeric: "auto",
    });

    const t1 = new Date();
    const t2 = new Date(date);

    // Date diff & convert from ms to minutes
    const diff = t2 - t1;

    return formatter.format(Math.round(diff / 86400000, 0), "day");
}
